import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from "../utils/config.service";
import { BaseService } from "./base.service";
import { Observable } from 'rxjs/Observable';
import { Subject } from "rxjs/Rx";
declare var $: any;
@Injectable()
export class ClientService extends BaseService {
  getAllClientUsersUrl: string;
  GetAllChildUserUrl: string;
  GetAllClientUser(value1: string, value2: string, value3: number, value4: number) {
    return this.http.get<any>(this.getAllClientUsersUrl + '/' + value1 + '/' + value2 + '/' + value3 + '/' + value4);
  }

  GetAllChildUser(value1: string, value2: string, value3: number, value4: number) {
    return this.http.get<any>(this.GetAllChildUserUrl + '/' + value1 + '/' + value2 + '/' + value3 + '/' + value4);
  }

  private client = new Subject<any>();
  testClientId: number = 0;
  baseApiUrl: string = '';
  getAllApiUrl: string = '';
  getclientIdApiUrl: string = '';
  clientBySubDomainUrl: string = '';
  getClientUrl: string = '';
  postClientUrl: string = '';
  putClientUrl: string = '';
  getClientByIdUrl: string = '';
  getAllUsersUrl: string = '';
  syncAppenateUserDataUrl: string = '';
  getClientUserUrl: string = '';

  public getClient() {
    return JSON.parse(localStorage.getItem('currentClient'));
  }

  public updateClient(client: any) {
    localStorage.setItem('currentClient', JSON.stringify(client));
  }

  getUpdatedClient(): Observable<any> {
    return this.client.asObservable();
  }

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.testClientId = this.configService.testClientId;
    this.baseApiUrl = this.configService.getApiURI();
    this.getAllApiUrl = this.baseApiUrl + '/client/list';
    this.getclientIdApiUrl = this.baseApiUrl + '/client/List';  // To get api in client list wise through client Id
    this.clientBySubDomainUrl = this.baseApiUrl + '/client/GetBySubDomain';
    this.getClientUrl = this.baseApiUrl + '/client/Get';
    this.postClientUrl = this.baseApiUrl + '/client/post';
    this.putClientUrl = this.baseApiUrl + '/client/put';
    this.getClientByIdUrl = this.baseApiUrl + '/client/GetClientById';
    this.getAllUsersUrl = this.baseApiUrl + '/ClientUserCount/GetAllUser';
    this.getAllClientUsersUrl = this.baseApiUrl + '/ClientUserCount/GetAllClientUser';
    this.GetAllChildUserUrl = this.baseApiUrl + '/ClientUserCount/GetAllChildUser';
    this.syncAppenateUserDataUrl = this.baseApiUrl + '/ClientUserCount/SyncAppenateUserData';
    this.getClientUserUrl = this.baseApiUrl + '/ClientUserDetails/GetClientUserDetails';

  }


  getAllUsers(clientID: string) {
    return this.http.get<any>(this.getAllUsersUrl + '/' + clientID);
  }

  getclientUsers(value1: string, value2: string) {
    return this.http.get<any>(this.getAllUsersUrl + '/' + value1 + '/' + value2);
  }

  syncAppenateUserData(clientID: string) {

    return this.http.get<any>(this.syncAppenateUserDataUrl + '/' + clientID);
  }


  // Client Id through fetch data records shows.
  getClientId(clientId: number) {

    return this.http.get<any>(this.getclientIdApiUrl + '/' + clientId);
  }

  // Get Clients

  getClients() {
    return this.http.get<any>(this.getAllApiUrl);
  }

  // Get Sub-Domain
  getSubdomain() {
    return localStorage.getItem('currentDomain');
  }

  // Set Client By Sub-Domain
  async setClientBySubDomain(subDomain: string) {
    localStorage.setItem('currentDomain', subDomain);
    if (subDomain != "localhost:4200") {
      var response = await this.http.get<any>(this.clientBySubDomainUrl + '/' + subDomain).toPromise<any>();
      let client = response;
      this.updateClient(client);
      return client;
    }
    else if (subDomain == "localhost:4200")
    {
      let client = await this.setClientById(this.testClientId.toString());
      this.updateClient(client);
      return client;
    }
    //if (subDomain == "localhost:4200") {
    //  return this.http.get<any>(this.clientBySubDomainUrl + '/' + subDomain)
    //    .map(response => {
    //      // login successful if there's a jwt token in the response
    //      let client = response;         
    //      this.updateClient(client);
    //      return client;
    //    }).catch(this.handleError);
    //}
    //else if (subDomain == "localhost:4200") {
    //  let client = await this.setClientById(this.testClientId.toString());
    //  this.updateClient(client);
    //  return client;
    //}
  }

  // Set Client By clientId
  async setClientById(clientId: string) {

    var client = await this.http.get<any>(this.getClientUrl + '/' + clientId).toPromise();
    this.updateClient(client);
    return client;

    //this.http.get<any>(this.getClientUrl + '/' + clientId)
    //          .map((response) =>
    //          {
    //            // login successful if there's a jwt token in the response
    //            let client = response;
    //            //this.setClientProperties(client); // why method calling? if method used then issue occurs.
    //            this.updateClient(client);
    //            return client;
    //          }).catch(this.handleError);


  }

  // Set Client Properties
  setClientProperties(client: any) {
    if (client != null && client.clientSetting != null && client.clientSetting.name != null)
      document.title = client.clientSetting.name || "Qubesense";

    if (client != null && client.clientSetting != null && client.clientSetting.siteSetting != null) {
      $("#favionPath").attr("href", client.clientSetting.siteSetting.faviconUrl);
    }
  }

  // Create Client
  post(clientModel: any) {
    return this.http.post(this.postClientUrl, clientModel).map(() => { }).catch(this.handleError);
  }

  // Edit Client

  put(clientModel: any) {
    return this.http.put<any>(this.putClientUrl, clientModel).map(() => { }).catch(this.handleError);
  }

  // Get Client By clientId
  getClientById(clientId: number) {
    return this.http.get(this.getClientByIdUrl + '/' + clientId);
  }
  // Get client user details
  getClientUserDetails(clientId: string, loginDay: number, loginMonth: number, year: number) {
    return this.http.get(this.getClientUserUrl + '/' + clientId + '/' + loginDay + '/' + loginMonth + '/' + year);
  }
}
